import axios from 'axios'
import {
	Message,
	MessageBox
} from 'element-ui'
import {
	getToken,
	removeToken
} from './auth'
import store from '@/store'

const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	// baseURL: 'https://api.pro.yuanpay.vip'
	// baseURL: 'https://api.zhystg.yuanpay.vip'
	// baseURL: '/api'
})
console.log(process.env.VUE_APP_BASE_API, "--->VUE_APP_BASE_API");

// 是否显示重新登录
export let isRelogin = {
	show: false
};

service.interceptors.request.use((req) => {
	const token = getToken()
	req.headers.Authorization = req.isNoToken ? '' : (token ? `Bearer ${token}` : '')
	if (req?.responseType) req.headers.responseType = req.responseType
	return req
}, (err) => Promise.reject(err))

service.interceptors.response.use((res) => {
	const {
		code,
		msg
	} = res.data || {}
	if (code === 202) {
		Message({
			message: res.data.msg,
			type: 'error',
			duration: 2 * 1000
		})
		if (!isRelogin.show) {
			isRelogin.show = true;
			MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
				confirmButtonText: '重新登录',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				isRelogin.show = false;
				store.dispatch('logOutTwo').then(() => {
					window.location.href = '/#/login'
				})
			}).catch(() => {
				isRelogin.show = false;
			});
		}
		return res.data
	} else if (code === 200) {
		return res.data
	} else {
		return Message({
			message: msg,
			type: 'error',
			duration: 2 * 1000
		})
	}

}, (err) => {


	const {
		msg,
		code
	} = err.response?.data || {}
	if (code === 202) {
		removeToken()
		window.location.href = '/#/login'
		return
	}
	console.log(err)
	if (msg) {
		Message({
			message: msg,
			type: 'error',
			duration: 2 * 1000
		})
	} else {
		Message({
			message: '服务器开小差了',
			type: 'error',
			duration: 2 * 1000
		})
	}

	Promise.reject(err)
})

export default service